module.exports = __webpack_public_path__ + "media/honey-icons/icon-multi-user-d3e45c92.svg";